<template>
  <div class="long-list-picker">
    <div
      v-if="showTitleBar"
      class="title"
    >
      <div
        class="cancel-button"
        @click="onCancel"
      >
        {{ cancelButtonText }}
      </div>
      <div class="van-ellipsis van-picker__title">
        {{ title }}
      </div>
      <div
        class="confirm-button"
        @click="onConfirm"
      >
        {{ confirmButtonText }}
      </div>
    </div>

    <van-search
      v-model="inputValue"
      show-action
      placeholder="输入关键词"
      @input="onInputSearch"
      @search="onSearch"
    >
      <template #action>
        <div @click="onClickButton">
          搜索
        </div>
      </template>
    </van-search>

    <div
      :class="showTitleBar ? 'list' : 'list withoutTitleBar'"
    >
      <van-list
        v-model="loading"
        v-bind="$attrs"
        :finished-text="finishedText"
        :error-text="errorText"
        @load="onLoad"
      >
        <van-cell
          v-for="option in options"
          :key="option[valueKey]"
          :class="option[valueKey] === selectedOption[valueKey] ? 'option selected' : 'option'"
          :title="option[labelKey]"
          @click="onClickListItem(option)"
        />
      </van-list>
    </div>
  </div>
</template>

<script>
import Search from 'vant/lib/search';
import List from 'vant/lib/list';
import Cell from 'vant/lib/cell';

import 'vant/lib/search/style';
import 'vant/lib/list/style';
import 'vant/lib/cell/style';

export default {
  name: 'LongListPicker',
  components: {
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
  },
  props: {
    finishedText: {
      type: String,
      default: '没有更多了',
    },
    errorText: {
      type: String,
      default: '请求失败，重新加载',
    },
    title: {
      type: String,
      default: '标题',
    },
    cancelButtonText: {
      type: String,
      default: '取消',
    },
    confirmButtonText: {
      type: String,
      default: '确认',
    },
    labelKey: {
      type: String,
      default: 'text',
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    showTitleBar: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      inputValue: '',
      loading: false,
      selectedOption: {},
    };
  },
  methods: {
    clearSearchKeyword() {
      this.inputValue = '';
    },

    onInputSearch(keyword) {
      this.$emit('on-input-search', (keyword || '').trim());
    },

    onSearch(keyword) {
      this.$emit('on-search', (keyword || '').trim());
    },

    onClickButton() {
      this.onSearch(this.inputValue);
    },

    onCancel() {
      this.$emit('on-cancel');
    },

    onClickListItem(option) {
      this.selectedOption = option;
      if (!this.showTitleBar) {
        this.$emit('on-select-option', option);
      }
    },

    onConfirm() {
      this.$emit('on-confirm', this.selectedOption);
    },

    onLoad() {
      this.loading = false;
      this.$emit('load');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/css/mixin';

.title {
  line-height: 0.88rem;
  height: 0.88rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.02rem solid #ebedf0;
}

.cancel-button,
.confirm-button {
  padding: 0 0.32rem;
  color: #1989fa;
  font-size: 0.28rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
</style>

<style lang="scss">
.long-list-picker {
  .option {
    opacity: 0.6;
    font-size: 0.32rem;

    &.selected {
      opacity: 1;
    }
  }

  .list {
    position: absolute;
    top: 1.96rem;
    left: 0;
    width: 100%;
    height: calc(100% - 1.96rem);
    overflow: auto;

    &.withoutTitleBar {
      top: 1.08rem;
      height: calc(100% - 1.08rem);
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
